(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-achievements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-about-carousel')) {
    customElements.define(
      'ck-about-carousel',
      class extends HTMLElement {
        static INTERVAL = 5000;

        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-slide-dot]'));
          this.toggle = this.querySelector('[data-carousel-toggle]');
          this.live = this.querySelector('[data-carousel-slides]');
          const controls = this.querySelector('[data-carousel-controls]');
          if (this.slides.length < 2 || !controls) return;

          controls.hidden = false;
          this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
          this.hovered = false;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.playing = !this.reduced;
          if (this.reduced && this.toggle) this.toggle.hidden = true;

          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.show(i)));
          this.toggle?.addEventListener('click', () => this.setPlaying(!this.playing));
          this.addEventListener('mouseenter', () => (this.hovered = true));
          this.addEventListener('mouseleave', () => (this.hovered = false));
          this.addEventListener('focusin', (event) => {
            if (event.target !== this.toggle) this.setPlaying(false);
          });
          this.onBlockSelect = (event) => {
            const i = this.slides.indexOf(event.target);
            if (i < 0) return;
            this.setPlaying(false);
            this.show(i);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);

          this.setPlaying(this.playing);
          this.timer = setInterval(() => this.tick(), this.constructor.INTERVAL);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        tick() {
          if (!this.playing || this.hovered || document.hidden) return;
          this.show((this.index + 1) % this.slides.length);
        }

        setPlaying(playing) {
          this.playing = playing;
          this.live?.setAttribute('aria-live', playing ? 'off' : 'polite');
          if (!this.toggle) return;
          this.toggle.classList.toggle('is-paused', !playing);
          this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.labelPause : this.toggle.dataset.labelPlay);
        }

        show(next) {
          if (next === this.index || !this.slides[next]) return;
          const current = this.slides[this.index];
          current.classList.remove('is-active');
          current.setAttribute('aria-hidden', 'true');
          this.dots[this.index]?.removeAttribute('aria-current');
          this.index = next;
          this.slides[next].classList.add('is-active');
          this.slides[next].removeAttribute('aria-hidden');
          this.dots[next]?.setAttribute('aria-current', 'true');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-app-video')) {
    customElements.define(
      'ck-app-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          this.toggle = this.querySelector('[data-play-toggle]');
          if (!this.video) return;
          this.video.muted = true;
          this.visible = false;
          this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.onToggle = () => {
            this.userPaused = !this.video.paused;
            if (this.userPaused) this.video.pause();
            else this.play();
          };
          this.onState = () => {
            if (this.toggle) this.toggle.setAttribute('aria-pressed', String(this.video.paused));
          };
          this.video.addEventListener('play', this.onState);
          this.video.addEventListener('pause', this.onState);
          if (this.toggle) {
            this.toggle.hidden = false;
            this.toggle.addEventListener('click', this.onToggle);
          }
          this.onState();
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                this.visible = entries.some((entry) => entry.isIntersecting);
                this.update();
              },
              { threshold: 0.25 }
            );
            this.observer.observe(this);
          } else {
            this.visible = true;
            this.update();
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.toggle?.removeEventListener('click', this.onToggle);
          this.video?.removeEventListener('play', this.onState);
          this.video?.removeEventListener('pause', this.onState);
        }

        play() {
          if (!this.video.getAttribute('src') && this.video.dataset.src) this.video.src = this.video.dataset.src;
          const playing = this.video.play();
          if (playing) playing.catch(() => this.onState());
        }

        update() {
          if (this.visible && !this.userPaused) this.play();
          else if (!this.video.paused) this.video.pause();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["core-guide-education"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-core-guide-video')) {
    customElements.define(
      'ck-core-guide-video',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.template = this.querySelector('[data-player-template]');
          this.player = this.querySelector('[data-player]');
          this.status = this.querySelector('[data-player-status]');
          if (!this.dialog || !this.template || !this.player) return;
          this.onOpen = () => this.mount();
          this.onClose = () => this.unmount();
          this.dialog.addEventListener('ck:open', this.onOpen);
          this.dialog.addEventListener('close', this.onClose);
        }

        disconnectedCallback() {
          this.dialog?.removeEventListener('ck:open', this.onOpen);
          this.dialog?.removeEventListener('close', this.onClose);
          this.unmount();
        }

        setStatus(text) {
          if (this.status) this.status.textContent = text || '';
        }

        mount() {
          if (this.player.querySelector('video, iframe')) return;
          const fragment = this.template.content.cloneNode(true);
          const media = fragment.querySelector('video, iframe');
          if (!media) {
            this.setStatus(this.dataset.error);
            return;
          }
          this.setStatus(this.dataset.loading);
          const ready = () => this.setStatus('');
          const failed = () => this.setStatus(this.dataset.error);
          if (media.tagName === 'VIDEO') {
            media.addEventListener('loadeddata', ready, { once: true });
            media.addEventListener(
              'error',
              (event) => {
                if (event.target === media || media.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) failed();
              },
              true
            );
          } else {
            media.addEventListener('load', ready, { once: true });
          }
          this.player.append(fragment);
          if (media.tagName === 'VIDEO') {
            const playing = media.play();
            if (playing) playing.catch(() => {});
          }
        }

        unmount() {
          if (!this.player) return;
          this.player.querySelectorAll('video').forEach((video) => {
            video.pause();
            video.removeAttribute('src');
            video.querySelectorAll('source').forEach((source) => source.remove());
            video.load();
          });
          this.player.querySelectorAll('video, iframe').forEach((node) => node.remove());
          this.setStatus('');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebook-lead-magnet"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-ebook-form')) {
    customElements.define(
      'ck-ebook-form',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          if (!this.form) return;
          this.email = this.querySelector('[data-ebook-email]');
          this.submit = this.querySelector('[data-ebook-submit]');
          const ownPost = window.location.hash === `#${this.form.id}`;
          const success = this.querySelector('[data-ebook-success]');
          const fields = this.querySelector('[data-ebook-fields]');
          const error = this.querySelector('[data-ebook-error]');

          if (success && !ownPost) {
            success.remove();
            if (fields) fields.hidden = false;
          } else if (success) {
            try {
              localStorage.setItem('ck-newsletter', 'done');
            } catch {}
            window.CK?.track?.lead('ebook_section', true);
            window.dispatchEvent(new Event('ck-newsletter-completed'));
            this.focusAfterLoad(success);
          }

          if (error && !ownPost) {
            error.remove();
            this.email?.removeAttribute('aria-invalid');
            this.email?.removeAttribute('aria-describedby');
          } else if (error && this.email) {
            this.focusAfterLoad(this.email);
          }

          this.onSubmit = () => this.handleSubmit();
          this.onPageShow = (event) => {
            if (event.persisted) this.setLoading(false);
          };
          this.form.addEventListener('submit', this.onSubmit);
          window.addEventListener('pageshow', this.onPageShow);
        }

        disconnectedCallback() {
          this.form?.removeEventListener('submit', this.onSubmit);
          window.removeEventListener('pageshow', this.onPageShow);
        }

        focusAfterLoad(element) {
          const run = () => window.setTimeout(() => element.focus({ preventScroll: true }), 60);
          if (document.readyState === 'complete') run();
          else window.addEventListener('load', run, { once: true });
        }

        setLoading(loading) {
          if (!this.submit) return;
          const label = this.submit.querySelector('[data-label]');
          this.submit.classList.toggle('is-loading', loading);
          this.submit.setAttribute('aria-busy', String(loading));
          if (!label) return;
          if (loading) {
            label.dataset.original = label.dataset.original || label.textContent;
            label.textContent = this.dataset.submitting || label.textContent;
          } else if (label.dataset.original) {
            label.textContent = label.dataset.original;
          }
        }

        handleSubmit() {
          this.setLoading(true);
          const config = window.CK_CONFIG || {};
          const endpoint = config.leadWebhook;
          const email = this.email ? this.email.value.trim() : '';
          if (!endpoint || !email) return;
          try {
            fetch(endpoint, {
              method: 'POST',
              mode: 'no-cors',
              keepalive: true,
              body: JSON.stringify({ email, source: 'ebook', locale: config.locale || document.documentElement.lang || 'en' }),
            }).catch(() => {});
          } catch {}
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-reviews-carousel')) {
    customElements.define(
      'ck-reviews-carousel',
      class extends HTMLElement {
        static PAUSE_MS = 8000;
        static SLIDE_MS = 700;

        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          this.count = this.slides.length;
          this.index = 0;
          if (!this.track || this.count === 0) return;

          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce || this.count < 2) {
            this.classList.add('is-static');
            this.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
            return;
          }

          this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot))));
          this.addEventListener('mouseenter', () => (this.paused = true));
          this.addEventListener('mouseleave', () => (this.paused = false));
          this.addEventListener('focusin', () => (this.paused = true));
          this.addEventListener('focusout', () => (this.paused = false));
          this.onResize = () => this.apply(false);
          window.addEventListener('resize', this.onResize);
          document.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail?.blockId);
            if (i >= 0) {
              this.paused = true;
              this.go(i);
            }
          });
          document.addEventListener('shopify:block:deselect', () => (this.paused = false));
          this.start();
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          clearTimeout(this.wrap);
          window.removeEventListener('resize', this.onResize);
        }

        start() {
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            if (!this.paused && !document.hidden) this.next();
          }, this.constructor.PAUSE_MS);
        }

        next() {
          this.index += 1;
          this.apply(true);
          if (this.index >= this.count) {
            clearTimeout(this.wrap);
            this.wrap = setTimeout(() => {
              this.index = 0;
              this.apply(false);
            }, this.constructor.SLIDE_MS);
          }
        }

        go(i) {
          clearTimeout(this.wrap);
          this.index = i;
          this.apply(true);
          this.start();
        }

        apply(animate) {
          const width = this.slides[0].getBoundingClientRect().width;
          this.track.style.transition = animate ? `transform ${this.constructor.SLIDE_MS}ms ease-in-out` : 'none';
          this.track.style.transform = `translateX(${-this.index * width}px)`;
          const active = this.index % this.count;
          this.dots.forEach((dot, i) => {
            if (i === active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('ck-nav-dropdown')) {
    customElements.define(
      'ck-nav-dropdown',
      class extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          this.hoverQuery = window.matchMedia('(hover: hover)');
          this.addEventListener('mouseenter', () => {
            if (this.hoverQuery.matches) this.details.open = true;
          });
          this.addEventListener('mouseleave', () => {
            if (this.hoverQuery.matches) this.details.open = false;
          });
          this.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.details.open) {
              this.details.open = false;
              this.summary.focus();
            }
          });
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.details.open = false;
          });
          this.onDocumentClick = (event) => {
            if (this.details.open && !this.contains(event.target)) this.details.open = false;
          };
          document.addEventListener('click', this.onDocumentClick);
        }

        disconnectedCallback() {
          document.removeEventListener('click', this.onDocumentClick);
        }
      }
    );
  }

  if (!customElements.get('ck-region-search')) {
    customElements.define(
      'ck-region-search',
      class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('[data-region-search]');
          this.items = Array.from(this.querySelectorAll('[data-region-item]'));
          this.empty = this.querySelector('[data-region-empty]');
          if (!this.input) return;
          this.input.addEventListener('input', () => this.filter());
          this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') event.preventDefault();
          });
          const dialog = this.closest('dialog');
          if (dialog) {
            dialog.addEventListener('ck:open', () => {
              const active = this.querySelector('.region-dialog__country.is-active');
              if (active) active.scrollIntoView({ block: 'center' });
            });
          }
        }

        filter() {
          const query = this.input.value.trim().toLowerCase();
          let visible = 0;
          for (const item of this.items) {
            const match = !query || item.dataset.terms.includes(query);
            item.hidden = !match;
            if (match) visible += 1;
          }
          if (this.empty) this.empty.hidden = visible > 0;
        }
      }
    );
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('#MobileMenu a[href]');
    if (link) {
      const dialog = document.getElementById('MobileMenu');
      if (dialog && dialog.open) dialog.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-cart-form')) {
    customElements.define(
      'ck-cart-form',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          if (!this.form) return;
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
        }

        onSubmit(event) {
          if (!event.submitter || event.submitter.name !== 'checkout') return;
          const collect = window.CK && window.CK.attribution && window.CK.attribution.collect;
          if (typeof collect !== 'function') return;
          let attributes = {};
          try {
            attributes = collect() || {};
          } catch {
            return;
          }
          this.form.querySelectorAll('[data-cart-attribute]').forEach((input) => input.remove());
          for (const [key, value] of Object.entries(attributes)) {
            if (!value) continue;
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `attributes[${key}]`;
            input.value = value;
            input.dataset.cartAttribute = '';
            this.form.append(input);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('ck-gallery')) {
    customElements.define(
      'ck-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gallery-track]');
          this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
          this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
          if (!this.track || this.thumbs.length < 2) return;
          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => this.go(Number(thumb.dataset.galleryThumb) - 1));
          });
          const observer = new IntersectionObserver(
            (entries) => {
              for (const entry of entries) {
                if (entry.isIntersecting) this.mark(this.slides.indexOf(entry.target));
              }
            },
            { root: this.track, threshold: 0.6 }
          );
          this.slides.forEach((slide) => observer.observe(slide));
        }

        go(index) {
          const slide = this.slides[index];
          if (!slide) return;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior });
          this.mark(index);
        }

        mark(index) {
          this.thumbs.forEach((thumb, i) => {
            if (i === index) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
        }
      }
    );
  }

  if (!customElements.get('ck-product')) {
    customElements.define(
      'ck-product',
      class extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-upsell-toggle]');
          this.buttons = Array.from(this.querySelectorAll('[data-buy-now]'));
          this.totals = Array.from(this.querySelectorAll('[data-total]'));
          this.sticky = this.querySelector('[data-sticky-buy]');
          this.mainCta = this.querySelector('[data-main-cta]');
          if (this.toggle) {
            this.toggle.addEventListener('change', () => this.update());
            this.update();
          }
          this.setupSticky();
        }

        update() {
          const withUpsell = Boolean(this.toggle && this.toggle.checked);
          const items = withUpsell ? this.dataset.upsellItems : this.dataset.baseItems;
          const total = withUpsell ? this.dataset.upsellTotal : this.dataset.baseTotal;
          this.buttons.forEach((button) => {
            button.dataset.items = items;
          });
          this.totals.forEach((node) => {
            node.textContent = total;
          });
          const swap = this.querySelector('[data-upsell-swap]');
          if (swap) swap.dataset.state = withUpsell ? 'claimed' : 'idle';
          const status = this.querySelector('[data-upsell-status]');
          if (status) status.textContent = withUpsell ? status.dataset.claimed : status.dataset.idle;
        }

        setupSticky() {
          if (!this.sticky || !this.mainCta || !('IntersectionObserver' in window)) return;
          this.sticky.hidden = false;
          const observer = new IntersectionObserver(
            ([entry]) => {
              const show = !entry.isIntersecting;
              this.sticky.classList.toggle('is-visible', show);
              this.sticky.toggleAttribute('inert', !show);
            },
            { threshold: 0 }
          );
          observer.observe(this.mainCta);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-whats-included"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-included-video')) {
    customElements.define(
      'ck-included-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                this.video.play().catch(() => {});
              } else {
                this.video.pause();
              }
            },
            { rootMargin: '200px 0px', threshold: 0.1 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"]) return;
  try {
    
  if (!customElements.get('ck-promo-popup')) {
    customElements.define(
      'ck-promo-popup',
      class extends HTMLElement {
        static STORAGE_KEY = 'ck-newsletter';
        static COMPLETED_EVENT = 'ck-newsletter-completed';

        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.form = this.querySelector('form');
          this.successPanel = this.querySelector('[data-promo-success-panel]');
          this.errorText = this.querySelector('[data-promo-error]');
          this.submitButton = this.querySelector('[data-promo-submit]');
          this.succeeded = false;
          if (!this.dialog || !this.form) return;

          this.querySelector('[data-promo-close]')?.addEventListener('click', () => this.dialog.close());
          this.querySelector('[data-promo-copy]')?.addEventListener('click', () => this.copy());
          this.dialog.addEventListener('close', () => {
            if (!this.succeeded) this.remember('dismissed');
          });
          this.form.addEventListener('submit', (event) => this.submit(event));
          window.addEventListener(this.constructor.COMPLETED_EVENT, () => {
            this.done = true;
            if (this.dialog.open && !this.succeeded) this.dialog.close();
          });

          const ownPost = window.location.hash === '#PromoPopupForm';
          if (ownPost && this.querySelector('[data-promo-posted]')) {
            this.showSuccess();
            window.CK?.track?.lead('newsletter_popup', true);
            this.open();
            return;
          }
          if (ownPost && this.errorText && !this.errorText.hidden) {
            this.open();
            return;
          }
          if (this.errorText) this.errorText.hidden = true;

          if (this.dataset.enabled !== 'true' || this.handled()) return;
          if (this.dataset.pageType === 'product' && this.dataset.showOnProduct !== 'true') return;
          this.arm();
        }

        handled() {
          try {
            return Boolean(localStorage.getItem(this.constructor.STORAGE_KEY));
          } catch {
            return false;
          }
        }

        remember(value) {
          try {
            localStorage.setItem(this.constructor.STORAGE_KEY, value);
          } catch {}
        }

        arm() {
          const delay = Math.max(0, Number(this.dataset.delay) || 18) * 1000;
          const trigger = () => {
            clearTimeout(this.timer);
            document.removeEventListener('mouseout', onLeave);
            this.whenBannerClosed(() => this.open());
          };
          const onLeave = (event) => {
            if (event.clientY <= 0) trigger();
          };
          this.timer = setTimeout(trigger, delay);
          if (this.dataset.exitIntent === 'true') document.addEventListener('mouseout', onLeave);
        }

        whenBannerClosed(callback) {
          let pending = false;
          try {
            const privacy = window.Shopify && window.Shopify.customerPrivacy;
            pending = Boolean(privacy && typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner() && !privacy.currentVisitorConsent()?.marketing);
          } catch {}
          if (pending) document.addEventListener('visitorConsentCollected', () => callback(), { once: true });
          else callback();
        }

        open() {
          if (this.done && !this.succeeded) return;
          if (this.dialog.open || document.querySelector('dialog[open]')) return;
          if (window.CK && window.CK.dialogs) window.CK.dialogs.open(this.dialog);
          else this.dialog.showModal();
        }

        showSuccess() {
          this.succeeded = true;
          this.remember('done');
          window.CK?.checkout?.rememberDiscount(this.dataset.code);
          this.form.hidden = true;
          if (this.successPanel) this.successPanel.hidden = false;
          this.querySelector('[data-promo-copy]')?.focus();
        }

        setLoading(loading) {
          if (!this.submitButton) return;
          this.submitButton.classList.toggle('is-loading', loading);
          this.submitButton.toggleAttribute('disabled', loading);
          const label = this.submitButton.querySelector('[data-label]');
          if (!label) return;
          if (loading) {
            label.dataset.original = label.textContent;
            label.textContent = this.dataset.submitting || label.textContent;
          } else if (label.dataset.original) {
            label.textContent = label.dataset.original;
          }
        }

        async submit(event) {
          event.preventDefault();
          if (this.loading) return;
          this.loading = true;
          this.setLoading(true);
          if (this.errorText) this.errorText.hidden = true;
          const email = this.form.querySelector('input[type=email]')?.value?.trim();
          const config = window.CK_CONFIG || {};
          if (config.leadWebhook && email) {
            try {
              fetch(config.leadWebhook, {
                method: 'POST',
                mode: 'no-cors',
                keepalive: true,
                body: JSON.stringify({ email, source: 'popup', locale: config.locale || 'en' }),
              }).catch(() => {});
            } catch {}
          }
          try {
            const response = await fetch(this.form.action, {
              method: 'POST',
              body: new FormData(this.form),
              credentials: 'same-origin',
            });
            if (response.url.includes('/challenge')) {
              this.form.submit();
              return;
            }
            const html = await response.text();
            if (response.ok && html.includes('data-promo-posted')) {
              this.showSuccess();
              window.CK?.track?.lead('newsletter_popup');
              window.dispatchEvent(new Event(this.constructor.COMPLETED_EVENT));
            } else {
              throw new Error('not subscribed');
            }
          } catch {
            if (this.errorText) this.errorText.hidden = false;
          } finally {
            this.loading = false;
            this.setLoading(false);
          }
        }

        async copy() {
          const code = this.dataset.code;
          const label = this.querySelector('[data-promo-copy-label]');
          try {
            await navigator.clipboard.writeText(code);
            if (label) {
              label.textContent = this.dataset.copied;
              setTimeout(() => {
                label.textContent = this.dataset.copy;
              }, 2000);
            }
          } catch {}
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-stats-marquee')) {
    customElements.define(
      'ck-stats-marquee',
      class extends HTMLElement {
        connectedCallback() {
          this.marquee = this.querySelector('.stats__marquee');
          this.toggle = this.querySelector('[data-play-toggle]');
          if (!this.marquee || !this.toggle) return;
          this.toggle.hidden = false;
          this.onToggle = () => {
            const paused = this.toggle.getAttribute('aria-pressed') !== 'true';
            this.toggle.setAttribute('aria-pressed', String(paused));
            this.marquee.classList.toggle('is-paused', paused);
          };
          this.toggle.addEventListener('click', this.onToggle);
        }

        disconnectedCallback() {
          this.toggle?.removeEventListener('click', this.onToggle);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ck-testimonials')) {
    customElements.define(
      'ck-testimonials',
      class extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('[data-scroller]');
          this.prev = this.querySelector('[data-scroll-prev]');
          this.next = this.querySelector('[data-scroll-next]');
          if (!this.scroller || !this.prev || !this.next) return;
          this.update = () => {
            const max = this.scroller.scrollWidth - this.scroller.clientWidth;
            this.prev.disabled = this.scroller.scrollLeft <= 1;
            this.next.disabled = this.scroller.scrollLeft >= max - 1;
          };
          this.onPrev = () => this.step(-1);
          this.onNext = () => this.step(1);
          this.prev.addEventListener('click', this.onPrev);
          this.next.addEventListener('click', this.onNext);
          this.scroller.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
        }

        disconnectedCallback() {
          this.prev?.removeEventListener('click', this.onPrev);
          this.next?.removeEventListener('click', this.onNext);
          this.scroller?.removeEventListener('scroll', this.update);
          window.removeEventListener('resize', this.update);
        }

        step(direction) {
          const item = this.scroller.querySelector('li');
          if (!item) return;
          const list = item.parentElement;
          const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scroller.scrollBy({
            left: direction * (item.getBoundingClientRect().width + gap),
            behavior: reduce ? 'auto' : 'smooth',
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
